import Service from '@ember/service';
import Evented from '@ember/object/evented';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class LiquidFireService extends Service.extend(Evented) {
  hasTransitionedAtLeastOnce = false;
  @tracked transitionCount = 0;

  get isAnimating() {
    return this.transitionCount > 0;
  }

  init() {
    super.init();

    this.on('transitionStart', this, this.onTransitionStart);
    this.on('transitionEnd', this, this.onTransitionEnd);
  }

  willDestroy() {
    super.willDestroy();

    this.off('transitionStart', this, this.onTransitionStart);
    this.off('transitionEnd', this, this.onTransitionEnd);
  }

  @action
  onTransitionStart() {
    this.transitionCount += 1;
    this.hasTransitionedAtLeastOnce = true;
  }

  @action
  onTransitionEnd() {
    this.transitionCount -= 1;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'liquid-fire': LiquidFireService;
  }
}
